import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import IconWrapper from './IconWrapper'

const MapPinIcon = ({ color, width, display, transform }) => (
  <IconWrapper
    width={width}
    height="100%"
    display={display}
    transform={transform}>
    <svg width="100%" height="100%" viewBox="0 0 18 22" fill="transparent">
      <g id="map-pin" clipPath="url(#clip0_52_77)">
        <path
          id="Vector"
          stroke={color}
          strokeWidth="0.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17.0999 8.99999C17.0999 15.3 8.9999 20.7 8.9999 20.7C8.9999 20.7 0.899902 15.3 0.899902 8.99999C0.899902 6.85174 1.75329 4.79147 3.27234 3.27243C4.79138 1.75338 6.85165 0.899994 8.9999 0.899994C11.1482 0.899994 13.2084 1.75338 14.7275 3.27243C16.2465 4.79147 17.0999 6.85174 17.0999 8.99999Z"
        />
        <path
          id="Vector_2"
          stroke={color}
          strokeWidth="0.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.9998 11.7C10.491 11.7 11.6998 10.4912 11.6998 8.99999C11.6998 7.50882 10.491 6.29999 8.9998 6.29999C7.50864 6.29999 6.2998 7.50882 6.2998 8.99999C6.2998 10.4912 7.50864 11.7 8.9998 11.7Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_52_77">
          <rect width="100%" height="100%" fill="#FFFFFF" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
)

MapPinIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  display: PropTypes.string,
  transform: PropTypes.string,
}

MapPinIcon.defaultProps = {
  color: theme.colors.coaldark,
  width: [],
  display: 'inline-block',
  transform: 'rotate(0)',
}

export default MapPinIcon
